import useFetch from 'use-http';
import { useEffect, useState } from 'react';
import { LINB_API } from '../../../constants/api-urls';
import { pmSensorAuthIdSelector } from 'state/selectors/sensors-authorizations';
import { useSelector } from 'react-redux';
import { normalizePMEntitiesDataFromDDB } from 'views/root/views/home/views/settings/views/ProjectManagement/services/project-management.service';
import { MAX_LIMIT_FOR_PM_ENTITIES } from '../useJiraEntities';

const useAzureBoardsEntities = () => {
  const pmSensorAuthId = useSelector(pmSensorAuthIdSelector);

  const [data, setData] = useState([]);
  const projectsAPI = useFetch(
    `${LINB_API.PM_SERVICE.PM_ENTITIES.PROJECTS}?limit=${MAX_LIMIT_FOR_PM_ENTITIES}`
  );

  const fetchEntities = async () => {
    const res = await projectsAPI.get();
    const normalizedEntities = normalizePMEntitiesDataFromDDB(res);

    setData(normalizedEntities);
  };

  useEffect(() => {
    if (pmSensorAuthId) fetchEntities();
  }, [pmSensorAuthId]);

  return {
    data,
    loading: projectsAPI.loading,
    error: projectsAPI.error
  };
};

export default useAzureBoardsEntities;
